import RulesPopup from '../popups/Rules/RulesPopup'
import SettingsPopup from '../popups/Settings/SettingsPopup'
import GameOverPopup from '../popups/GameOver/GameOverPopup'
import DrawProposalPopup from '../popups/DrawProposal/DrawProposalPopup'
import SurrenderPopup from '../popups/Surrender/SurrenderPopup'
import ErrorPopup from '../popups/Error/ErrorPopup'
import AwaitingPopup from '../popups/Awaiting/AwaitingPopup'
import SoundManager from '../../../soundManager/SoundManager'
import POPUP from '../../../../constants/popup'

const GamePopup = ({
  type,
  data,
  playerColor,
  signInPage,
  onRetry,
  onClose,
  onProposeDraw,
  onSurrender,
  onNewGame,
  onNewArenaGame,
  isAnonymous,
  isAllPiecesCaptured,
  player,
  gameIcon,
  tournament,
}) => {
  switch (type) {
    case POPUP.AWAITING_OPPONENT:
      return (
        <AwaitingPopup
          notFound={data ? data.notFound : null}
          onRetry={onRetry}
          onClose={onClose}
        />
      )
    case POPUP.DRAW_PROPOSAL_CONFIRM:
      return (
        <DrawProposalPopup
          onProposeDraw={onProposeDraw}
          onClose={onClose}
        />
      )
    case POPUP.SURRENDER_CONFIRM:
      return <SurrenderPopup onSurrender={onSurrender} onClose={onClose} />
    case POPUP.GAME_OVER_POPUP:
      return (
        <GameOverPopup
          gameResult={data}
          playerColor={playerColor}
          signInPage={signInPage}
          isAnonymous={isAnonymous}
          onClose={onClose}
          onNewGame={onNewGame}
          onNewArenaGame={onNewArenaGame}
          isAllPiecesCaptured={isAllPiecesCaptured}
          player={player}
          gameIcon={gameIcon}
          tournament={tournament}
        />
      )
    case POPUP.ERROR_POPUP:
      SoundManager.stopAll()
      return (
        <ErrorPopup
          title={data.title}
          text={data.message}
          onClose={onClose}
          buttons={[{ text: 'New game', handler: onNewGame }]}
        />
      )
    case POPUP.RULES:
      return <RulesPopup rules={data.rules} onClose={onClose} />
    case POPUP.SETTINGS:
      return <SettingsPopup onClose={onClose} />
    default:
      return null
  }
}

export default GamePopup
